import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define your user and role types
interface UserRole {
  roleId: number;
}

interface UserSlice {
  userId: number;
  name: string;
  email: string;
  userRoles?: UserRole[];
  clientId: number;
  Role: string;
  roleId: number;
  type: string;
  isDivisionUser: boolean | string | null;
  division_id: null | number;
  gracePeriodRemaining: number | null;
  isSubscriptionExpired: boolean;
  freeTierComplete?: boolean;
}

// Define the state type
interface UserState {
  user: UserSlice | null;
  selectedRole: UserRole[] | null;
}

// Initial state
const initialState: UserState = {
  user: null,
  selectedRole: null,
};

// Create slice
const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    userLogin(state, action: PayloadAction<{ user: UserSlice | null }>) {
      const raw = action.payload.user as (UserSlice & { client_id?: number }) | null;
      if (!raw) {
        state.user = null;
        state.selectedRole = null;
        localStorage.setItem("lastLogin", new Date().toISOString());
        return;
      }
      // API returns client_id (snake_case); ensure clientId is set for components
      state.user = {
        ...raw,
        clientId: raw.clientId ?? raw.client_id ?? 0,
      };
      state.selectedRole = raw.userRoles ?? null;
      localStorage.setItem("lastLogin", new Date().toISOString());
    },

    userLogout(state) {
      state.user = null;
      state.selectedRole = null;
      localStorage.removeItem("lastLogin");
    },

    changeRole(state, action: PayloadAction<{ selectedRole: UserRole[] }>) {
      if (state.selectedRole !== action.payload.selectedRole) {
        state.selectedRole = action.payload.selectedRole;
      }
    },
  },
});

export default user.reducer;
export const { userLogin, userLogout, changeRole } = user.actions;
